(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('ContractMinDTO', ContractMinDTO);

    ContractMinDTO.$inject = ['$resource', 'DateUtils'];

    function ContractMinDTO ($resource, DateUtils) {
        var resourceUrl =  'api/contractMinDTO/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.contractDate = DateUtils.convertLocalDateFromServer(data.contractDate);
                    }
                    return data;
                }
            }
        });
    }
})();
